export default {"src":"/_next/static/media/about-benefit-2.4a048b16.svg","height":194,"width":226,"blurWidth":0,"blurHeight":0};